<template>
    <a v-if="actionable" :href="anchorHref" v-bind="linkAttrs" @click="doAction" class="fd-ea-actionable" ref="alink">
        <slot></slot>
    </a>
    <span v-else class="fd-ea-nonactionable"><slot></slot></span>
</template>

<script setup lang="ts">
import {computed, inject, ref} from "vue";
import type {EAMeta} from "./EAResolver";
import resolve from "./EAResolver";
import {injectEnv} from "../../Environment";
import {injectContext} from "@t/fd/AppContext.ts";

export interface EaActionProps {
    meta?: EAMeta,
    value?: string,
    raw?: string
}

const uprops = defineProps({
    meta: Object,
    type: Number,
    value: {type: String, default: null},
    raw: String
});
const props = uprops as EaActionProps;
const alink = ref<null|HTMLElement>(null);

const env = injectEnv();

const eaMeta = computed<EAMeta>(() => {
    if (props.meta) return props.meta;
    else return resolve(props.value, props.raw);
});
const actionable = computed(() => {
    const m = eaMeta.value;
    return m.ok && !m.empty;
});

const anchorHref = computed(() => {
    const m = eaMeta.value;
    if (m.ok && m.href) return m.href;
    return "#";
});

const linkAttrs = computed(() => {
	const m = eaMeta.value;
	const bind = {};
	if (m.ok && m.href && m.target) bind.target = m.target;
	return bind;
});

const ctx = injectContext();

function doAction(event: MouseEvent) {
    if (alink.value) {
        const m = eaMeta.value;
		const success = env.actionLink(m.type, m.raw ? m.raw : m.value, alink.value, ctx.value);
        if (success) event.preventDefault();
    }
}
</script>

<style>
.fd-ea-actionable {
    --link-fg: var(--fg);
    position: relative;
}

.fd-ea-nonactionable {
}
</style>